import HowToArticle from 'components/articles/HowToArticle';
import { Link as MuiLink } from '@material-ui/core';
import { Link } from 'react-router-dom';
import resizeImage from 'components/articles/how-to-resize-an-image.png';
import Hint from 'components/articles/Hint';

const image = {
  src: resizeImage,
  width: 1060,
  height: 1060,
  alt: 'PhotoUtils screenshot: how to resize a picture online',
  title: 'How to resize a picture using PhotoUtils',
  type: 'image/png',
};

function HowToResize() {
  return (
    <HowToArticle
      action="resize"
      description="Simple way to resize a picture online to a specific size in pixels. Learn how to upscale or downscale a photo, adopt it to social media image sizes."
      image={image}
      publishedTime={'2020-11-27T15:27:38'}
      modifiedTime={'2020-11-27T15:27:38'}
    >
      Often you have a high quality and high resolution pictures from your phone or camera. They are great for a
      personal photo library but high resolution makes files pretty big. You can't upload them to social media and other
      websites because upper limit is typically 5-10 MB. To significantly reduce the file size you can downscale and
      resize such pictures. Here is how to do it using PhotoUtils in 3 simple steps:
      <ol>
        <li>
          Go to{' '}
          <MuiLink to="/" component={Link}>
            PhotoUtils home page
          </MuiLink>
          , upload your picture and open the <strong>Resize</strong> tool
        </li>
        <li>Adjust width and height</li>
        <li>
          Click <strong>Resize</strong> to download adjusted image
        </li>
      </ol>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img {...image} />
      <Hint>
        Special tip for SMM specialists. There is a handy list of social media image sizes. Select the recommended
        Instagram post size, Facebook profile picture size and many more. Click{' '}
        <strong>Social media image sizes</strong> to check all options.
      </Hint>
    </HowToArticle>
  );
}

export default HowToResize;
